webpackJsonp([74],{

/***/ 1268:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_date_fns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_mixins__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_helper__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_shared_ButtonCreate__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_shared_ButtonCreate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_shared_ButtonCreate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_filters__ = __webpack_require__(278);





var loadData = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
		var response;
		return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.next = 2;
						return this.$http.get('//pms.controlinn.com/api' + '/bookings/' + this.bookingCode);

					case 2:
						response = _context.sent;

						this.model = response.data.data;

					case 4:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function loadData() {
		return _ref.apply(this, arguments);
	};
}();

var loadResources = function () {
	var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
		var _this = this;

		var user, request, responses;
		return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						user = helperMethods.getUser();
						request = [this.$http.get('//ws.controlinn.com/webservice' + '/poll/datacompany/' + user.company_id), this.$http.get('//pms.controlinn.com/api' + '/channels'), this.$http.get('//pms.controlinn.com/api' + '/roomtype/' + this.hotelId)];
						_context2.next = 4;
						return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(request);

					case 4:
						responses = _context2.sent;

						this.countries = responses[0].data.data.countries;
						this.channels = responses[1].data.data;
						this.roomsType = responses[2].data.data;
						responses[1].data.data.forEach(function (channel) {
							_this.dataModel[channel.id].country = '' + 172;
						});
						this.guests = this.guests.map(function (guest) {
							var newGuest = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, guest);
							newGuest.country = '' + 172;
							return newGuest;
						});

					case 10:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this);
	}));

	return function loadResources() {
		return _ref2.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var helperMethods = __WEBPACK_IMPORTED_MODULE_6__shared_helper__["a" /* default */].methods;

function created() {
	this.loadResources();
	this.loadData();
}

function addGuest() {
	var model = {
		additionals: [],
		babys: 0,
		birthDate: null,
		children: 0,
		civilState: 2,
		country: 'Perú',
		document: '',
		email: '',
		gender: 1,
		lastname: '',
		mediaSelected: 'E-mail',
		menuBirthDate: false,
		name: '',
		operator: '',
		phone: '',
		room: null,
		roomType: null,
		seller: '',
		typeDocument: 2,
		vipCard: ''
	};
	this.guests.push(model);
}

function allowedDatesOut(date) {
	var newDay = new Date(this.dateEnter).getDate() + 2;
	var newMonth = new Date(this.dateEnter).getMonth() + 1;
	var newYear = new Date(this.dateEnter).getFullYear();
	var newDate = newYear + '-' + newMonth + '-' + newDay;
	return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["isAfter"])(new Date(date), new Date(newDate));
}

function arrowIconBirth() {
	var arrow = this.onChange ? 'arrow_drop_up' : 'arrow_drop_down';
	return arrow;
}

function bookingQuantityNights() {
	return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["differenceInDays"])(new Date(this.dateOut), new Date(this.dateEnter));
}

function changeFormatDate(value) {
	return new Date(value).toISOString().substr(0, 10);
}

function changeIcon(result) {
	this.onChange = result;
}

function toggleIconBirthDate() {
	this.onChange = !this.modal.birthDate;
}

function totalAmount() {
	return this.selectedAdditionals.reduce(function (acum, add) {
		return acum + add.price;
	}, 0);
}

function validDate(date) {
	this.dateOut = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["differenceInDays"])(new Date(this.dateOut), new Date(date)) < 0 ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["format"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["addDays"])(new Date(date), 2), 'YYYY-MM-DD') : this.dateOut;
}

function data() {
	return {
		additionals: [{ id: 1, name: 'Alojamiento', price: 45 }, { id: 2, name: 'AA BN', price: 45 }, { id: 3, name: 'B.A', price: 45 }, { id: 4, name: 'Lavandería', price: 45 }, { id: 5, name: 'Traslados', price: 45 }, { id: 6, name: 'QP Store', price: 45 }, { id: 7, name: 'Frigobar', price: 45 }, { id: 8, name: 'Telefonía', price: 45 }],
		channel: 1,
		channels: [],
		civilStatus: [{ id: 1, value: 'Soltero' }, { id: 2, value: 'Casado' }, { id: 3, value: 'Viudo' }, { id: 4, value: 'Divorciado' }],
		countries: [],
		dataModel: {
			1: {
				active: true,
				country: 0,
				email: '',
				lastname: '',
				name: '',
				phone: '',
				title: 'Datos de Walk-in'
			},
			2: {
				active: true,
				country: 0,
				documentNumber: null,
				email: '',
				lastname: '',
				name: '',
				phone: '',
				title: 'Datos de Empresa'
			},
			3: {
				active: true,
				country: 0,
				email: '',
				fileNumber: '',
				lastname: '',
				name: '',
				phone: '',
				title: 'Datos de Agencia'
			},
			4: {
				active: true,
				country: 0,
				email: '',
				lastname: '',
				name: '',
				phone: '',
				title: 'Datos de OTA',
				voucher: ''
			},
			5: {
				active: true,
				bookingNumber: '',
				country: 0,
				email: '',
				lastname: '',
				name: '',
				phone: '',
				title: 'Datos de Página Web'
			}
		},
		dateCreation: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["format"])(new Date(), 'YYYY-MM-DD'),
		dateEnter: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["format"])(new Date(), 'YYYY-MM-DD'),
		dateOut: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["format"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["addDays"])(new Date(), 1), 'YYYY-MM-DD'),
		formatted: null,
		genders: [{ id: 1, value: 'Varón' }, { id: 2, value: 'Mujer' }],
		guests: [{
			additionals: [],
			babys: 0,
			birthDate: null,
			children: 0,
			civilState: 2,
			country: 0,
			document: '',
			email: '',
			gender: 1,
			lastname: '',
			mediaSelected: 'E-mail',
			menuBirthDate: false,
			name: '',
			operator: '',
			phone: '',
			room: null,
			roomType: null,
			seller: '',
			typeDocument: 2,
			vipCard: ''
		}],
		media: ['E-mail'],
		menuCreation: false,
		menuEnter: false,
		menuOut: false,
		model: {},
		onChange: false,
		roomsType: [],
		selectedAdditionals: [],
		typeDocuments: [{ id: 1, value: 'DNI' }, { id: 2, value: 'Pasaporte' }]
	};
}

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'check-in-form',
	components: {
		ButtonCreate: __WEBPACK_IMPORTED_MODULE_7__components_shared_ButtonCreate___default.a
	},
	computed: {
		arrowIconBirth: arrowIconBirth,
		bookingQuantityNights: bookingQuantityNights,
		totalAmount: totalAmount
	},
	created: created,
	data: data,
	filters: {
		round: __WEBPACK_IMPORTED_MODULE_8__shared_filters__["c" /* round */]
	},
	methods: {
		addGuest: addGuest,
		allowedDatesOut: allowedDatesOut,
		changeFormatDate: changeFormatDate,
		changeIcon: changeIcon,
		loadData: loadData,
		loadResources: loadResources,
		toggleIconBirthDate: toggleIconBirthDate,
		validDate: validDate
	},
	mixins: __WEBPACK_IMPORTED_MODULE_5__shared_mixins__["a" /* default */],
	props: ['bookingCode', 'hotelId']
});

/***/ }),

/***/ 1367:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(772)(true);
// imports


// module
exports.push([module.i, ".form-button[data-v-04efa2f2]{background-color:transparent;-webkit-box-shadow:none;box-shadow:none}.form-button .btn[data-v-04efa2f2]{background-color:#7e7e7e!important;border-radius:0;-webkit-box-shadow:0 2px 4px 0 rgba(0,0,0,.18)!important;box-shadow:0 2px 4px 0 rgba(0,0,0,.18)!important;color:#fff;height:40px;margin-right:14px;min-width:98px;opacity:1}.form-button .btn--active[data-v-04efa2f2]{background-color:#29abe2!important}.divider-form[data-v-04efa2f2]{margin:0 -20px;width:100vw}.chip[data-v-04efa2f2]{background-color:#29abe2;border-radius:0;-webkit-box-shadow:none!important;box-shadow:none!important;font-size:10px;height:18px;line-height:18px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding:0;text-transform:uppercase;width:65px}.disabled-block[data-v-04efa2f2]{opacity:.5}.btn-save-form[data-v-04efa2f2]{max-width:100%!important}", "", {"version":3,"sources":["/opt/build/repo/src/clerkinn/checkin/Form.vue"],"names":[],"mappings":"AACA,8BACE,6BAA8B,AAC9B,wBAAyB,AACjB,eAAiB,CAC1B,AACD,mCACI,mCAAqC,AACrC,gBAAmB,AACnB,yDAA+D,AACvD,iDAAuD,AAC/D,WAAa,AACb,YAAa,AACb,kBAAmB,AACnB,eAAgB,AAChB,SAAW,CACd,AACD,2CACM,kCAAqC,CAC1C,AACD,+BACE,eAAgB,AAChB,WAAa,CACd,AACD,uBACE,yBAA0B,AAC1B,gBAAmB,AACnB,kCAAoC,AAC5B,0BAA4B,AACpC,eAAgB,AAChB,YAAa,AACb,iBAAkB,AAClB,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,UAAa,AACb,yBAA0B,AAC1B,UAAY,CACb,AACD,iCACE,UAAY,CACb,AACD,gCACE,wBAA2B,CAC5B","file":"Form.vue","sourcesContent":["/*-----------------------------------------------------------------------------*/\n.form-button[data-v-04efa2f2] {\n  background-color: transparent;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.form-button .btn[data-v-04efa2f2] {\n    background-color: #7e7e7e !important;\n    border-radius: 0px;\n    -webkit-box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.18) !important;\n            box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.18) !important;\n    color: white;\n    height: 40px;\n    margin-right: 14px;\n    min-width: 98px;\n    opacity: 1;\n}\n.form-button .btn--active[data-v-04efa2f2] {\n      background-color: #29abe2 !important;\n}\n.divider-form[data-v-04efa2f2] {\n  margin: 0 -20px;\n  width: 100vw;\n}\n.chip[data-v-04efa2f2] {\n  background-color: #29abe2;\n  border-radius: 0px;\n  -webkit-box-shadow: none !important;\n          box-shadow: none !important;\n  font-size: 10px;\n  height: 18px;\n  line-height: 18px;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  padding: 0px;\n  text-transform: uppercase;\n  width: 65px;\n}\n.disabled-block[data-v-04efa2f2] {\n  opacity: .5;\n}\n.btn-save-form[data-v-04efa2f2] {\n  max-width: 100% !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1452:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1367);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(773)("cbd35f88", content, true);

/***/ }),

/***/ 1574:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-left": "",
      "mb-4": ""
    }
  }, [_c('v-btn-toggle', {
    staticClass: "form-button",
    model: {
      value: (_vm.channel),
      callback: function($$v) {
        _vm.channel = $$v
      },
      expression: "channel"
    }
  }, _vm._l((_vm.channels), function(channelType) {
    return _c('v-btn', {
      key: channelType.id,
      class: {
        'btn--active': _vm.channel === channelType.id
      },
      attrs: {
        "flat": "",
        "disabled": _vm.channel === channelType.id,
        "value": channelType.id
      }
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(channelType.name) + "\n\t\t\t\t")])
  }))], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-divider', {
    staticClass: "divider-form"
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('p', {
    staticClass: "title-form"
  }, [_vm._v("Datos de reserva")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "text-xs-right": ""
    }
  }, [_c('v-chip', {
    staticClass: "white--text"
  }, [_vm._v("Cliente Vip")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-subheader', {
    staticClass: "pl-0"
  }, [_vm._v("Fecha de creación")]), _vm._v(" "), _c('v-menu', {
    staticClass: "menu-date-picker menu-form",
    attrs: {
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "max-width": "290px"
    },
    model: {
      value: (_vm.menuCreation),
      callback: function($$v) {
        _vm.menuCreation = $$v
      },
      expression: "menuCreation"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Fecha de creación",
      "append-icon": "event",
      "single-line": "",
      "hide-details": "",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.dateCreation),
      callback: function($$v) {
        _vm.dateCreation = $$v
      },
      expression: "dateCreation"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "locale": "es-PE",
      "date-format": _vm.changeFormatDate,
      "formatted-value": _vm.formatted,
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.dateCreation),
      callback: function($$v) {
        _vm.dateCreation = $$v
      },
      expression: "dateCreation"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-subheader', {
    staticClass: "pl-0"
  }, [_vm._v("Fecha de ingreso")]), _vm._v(" "), _c('v-menu', {
    staticClass: "menu-date-picker menu-form",
    attrs: {
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "max-width": "290px"
    },
    model: {
      value: (_vm.menuEnter),
      callback: function($$v) {
        _vm.menuEnter = $$v
      },
      expression: "menuEnter"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Fecha de ingreso",
      "append-icon": "event",
      "single-line": "",
      "hide-details": "",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.dateEnter),
      callback: function($$v) {
        _vm.dateEnter = $$v
      },
      expression: "dateEnter"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "locale": "es-PE",
      "date-format": _vm.changeFormatDate,
      "formatted-value": _vm.formatted,
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "input": _vm.validDate
    },
    model: {
      value: (_vm.dateEnter),
      callback: function($$v) {
        _vm.dateEnter = $$v
      },
      expression: "dateEnter"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-subheader', {
    staticClass: "pl-0"
  }, [_vm._v("Fecha de salida")]), _vm._v(" "), _c('v-menu', {
    staticClass: "menu-date-picker menu-form",
    attrs: {
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "max-width": "290px"
    },
    model: {
      value: (_vm.menuOut),
      callback: function($$v) {
        _vm.menuOut = $$v
      },
      expression: "menuOut"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Fecha de salida",
      "append-icon": "event",
      "single-line": "",
      "hide-details": "",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.dateOut),
      callback: function($$v) {
        _vm.dateOut = $$v
      },
      expression: "dateOut"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "locale": "es-PE",
      "date-format": _vm.changeFormatDate,
      "formatted-value": _vm.formatted,
      "allowed-dates": _vm.allowedDatesOut,
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.dateOut),
      callback: function($$v) {
        _vm.dateOut = $$v
      },
      expression: "dateOut"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-subheader', {
    staticClass: "pl-0"
  }, [_vm._v("Cantidad de noches")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-border-inset",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    model: {
      value: (_vm.bookingQuantityNights),
      callback: function($$v) {
        _vm.bookingQuantityNights = $$v
      },
      expression: "bookingQuantityNights"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "mt-4": ""
    }
  }, [_c('v-divider', {
    staticClass: "divider-form"
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "title-form"
  }, [_vm._v("Completa los datos")])]), _vm._v(" "), _vm._l((_vm.guests), function(model, indexModel) {
    return _c('v-flex', {
      key: indexModel,
      attrs: {
        "xs12": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": "",
        "text-xs-left": "",
        "mb-3": ""
      }
    }, [_c('v-flex', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.guests.length > 1),
        expression: "guests.length > 1"
      }],
      attrs: {
        "xs12": ""
      }
    }, [_vm._v("\n\t\t\t\t\tPersona " + _vm._s(indexModel + 1) + "\n\t\t\t\t")])], 1), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": "",
        "text-xs-left": "",
        "mb-3": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Tipo de Habitación")]), _vm._v(" "), _c('v-select', {
      staticClass: "filter-select",
      attrs: {
        "items": _vm.roomsType,
        "item-text": "name",
        "item-value": "id",
        "hide-details": "",
        "label": "Standart",
        "single-line": "",
        "bottom": ""
      },
      model: {
        value: (model.roomType),
        callback: function($$v) {
          model.roomType = $$v
        },
        expression: "model.roomType"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Nº de Habitación")]), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset",
      attrs: {
        "type": "text",
        "placeholder": "101"
      },
      model: {
        value: (model.room),
        callback: function($$v) {
          model.room = $$v
        },
        expression: "model.room"
      }
    })], 1)], 1), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": "",
        "text-xs-left": "",
        "mb-3": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Nombres")]), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset",
      attrs: {
        "type": "text",
        "placeholder": "Completos"
      },
      model: {
        value: (model.name),
        callback: function($$v) {
          model.name = $$v
        },
        expression: "model.name"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Apellidos")]), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset",
      attrs: {
        "type": "text",
        "placeholder": "Completos"
      },
      model: {
        value: (model.lastname),
        callback: function($$v) {
          model.lastname = $$v
        },
        expression: "model.lastname"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Fecha de nacimiento")]), _vm._v(" "), _c('v-menu', {
      staticClass: "menu-date-picker",
      attrs: {
        "lazy": "",
        "transition": "scale-transition",
        "offset-y": "",
        "full-width": "",
        "max-width": "290px"
      },
      on: {
        "input": _vm.changeIcon
      },
      model: {
        value: (model.menuBirthDate),
        callback: function($$v) {
          model.menuBirthDate = $$v
        },
        expression: "model.menuBirthDate"
      }
    }, [_c('v-text-field', {
      attrs: {
        "label": "Fecha de nacimiento",
        "append-icon": _vm.arrowIconBirth,
        "append-icon-cb": _vm.toggleIconBirthDate,
        "single-line": "",
        "hide-details": "",
        "readonly": ""
      },
      slot: "activator",
      model: {
        value: (model.birthDate),
        callback: function($$v) {
          model.birthDate = $$v
        },
        expression: "model.birthDate"
      }
    }), _vm._v(" "), _c('v-date-picker', {
      attrs: {
        "locale": "es-PE",
        "date-format": _vm.changeFormatDate,
        "formatted-value": _vm.formatted,
        "no-title": "",
        "scrollable": ""
      },
      model: {
        value: (model.birthDate),
        callback: function($$v) {
          model.birthDate = $$v
        },
        expression: "model.birthDate"
      }
    })], 1)], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("País")]), _vm._v(" "), _c('v-select', {
      staticClass: "filter-select",
      attrs: {
        "autocomplete": "",
        "items": _vm.countries,
        "item-text": "name",
        "item-value": "id",
        "hide-details": "",
        "single-line": "",
        "bottom": ""
      },
      model: {
        value: (model.country),
        callback: function($$v) {
          model.country = $$v
        },
        expression: "model.country"
      }
    })], 1)], 1), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": "",
        "text-xs-left": "",
        "mb-3": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Género")]), _vm._v(" "), _c('v-select', {
      staticClass: "filter-select",
      attrs: {
        "item-text": "value",
        "item-value": "id",
        "items": _vm.genders,
        "hide-details": "",
        "single-line": "",
        "bottom": ""
      },
      model: {
        value: (model.gender),
        callback: function($$v) {
          model.gender = $$v
        },
        expression: "model.gender"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Estado civil")]), _vm._v(" "), _c('v-select', {
      staticClass: "filter-select",
      attrs: {
        "item-text": "value",
        "item-value": "id",
        "items": _vm.civilStatus,
        "hide-details": "",
        "single-line": "",
        "bottom": ""
      },
      model: {
        value: (model.civilState),
        callback: function($$v) {
          model.civilState = $$v
        },
        expression: "model.civilState"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Correo electrónico")]), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset",
      attrs: {
        "type": "text",
        "placeholder": "nombre@mail.com"
      },
      model: {
        value: (model.email),
        callback: function($$v) {
          model.email = $$v
        },
        expression: "model.email"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Tipo de identificación")]), _vm._v(" "), _c('v-select', {
      staticClass: "filter-select filter-select-indicator",
      attrs: {
        "item-text": "value",
        "item-value": "id",
        "items": _vm.typeDocuments,
        "hide-details": "",
        "single-line": "",
        "bottom": ""
      },
      model: {
        value: (model.typeDocument),
        callback: function($$v) {
          model.typeDocument = $$v
        },
        expression: "model.typeDocument"
      }
    }), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset input-form-select",
      attrs: {
        "type": "number"
      },
      model: {
        value: (model.document),
        callback: function($$v) {
          model.document = $$v
        },
        expression: "model.document"
      }
    })], 1)], 1), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": "",
        "text-xs-left": "",
        "mb-3": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Niños")]), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset",
      attrs: {
        "type": "text",
        "readonly": "",
        "placeholder": "0"
      },
      model: {
        value: (model.children),
        callback: function($$v) {
          model.children = $$v
        },
        expression: "model.children"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Bebés")]), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset",
      attrs: {
        "type": "text",
        "readonly": "",
        "placeholder": "0"
      },
      model: {
        value: (model.babys),
        callback: function($$v) {
          model.babys = $$v
        },
        expression: "model.babys"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Teléfono")]), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset",
      attrs: {
        "type": "text",
        "readonly": ""
      },
      model: {
        value: (model.phone),
        callback: function($$v) {
          model.phone = $$v
        },
        expression: "model.phone"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Nº de Tarjeta Vip")]), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset",
      attrs: {
        "type": "text",
        "readonly": ""
      },
      model: {
        value: (model.vipCard),
        callback: function($$v) {
          model.vipCard = $$v
        },
        expression: "model.vipCard"
      }
    })], 1)], 1), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": "",
        "text-xs-left": "",
        "mb-3": ""
      }
    }, [_c('v-flex', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.channel === 2),
        expression: "channel === 2"
      }],
      attrs: {
        "xs3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Operador")]), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset",
      attrs: {
        "type": "text",
        "readonly": ""
      },
      model: {
        value: (model.operator),
        callback: function($$v) {
          model.operator = $$v
        },
        expression: "model.operator"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Vendedor")]), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset",
      attrs: {
        "type": "text",
        "readonly": ""
      },
      model: {
        value: (model.seller),
        callback: function($$v) {
          model.seller = $$v
        },
        expression: "model.seller"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Modo de captura")]), _vm._v(" "), _c('v-select', {
      staticClass: "filter-select",
      attrs: {
        "items": _vm.media,
        "hide-details": "",
        "single-line": "",
        "bottom": ""
      },
      model: {
        value: (model.mediaSelected),
        callback: function($$v) {
          model.mediaSelected = $$v
        },
        expression: "model.mediaSelected"
      }
    })], 1)], 1)], 1)
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('button-create', {
    staticClass: "justify-center",
    attrs: {
      "btn-function": "",
      "text": "Agregar a otra persona"
    },
    on: {
      "function-click": _vm.addGuest
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "mt-4": ""
    }
  }, [_c('v-divider', {
    staticClass: "divider-form"
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-switch', {
    staticClass: "input-switch",
    attrs: {
      "label": _vm.dataModel[_vm.channel].title,
      "color": "success",
      "hide-details": ""
    },
    model: {
      value: (_vm.dataModel[_vm.channel].active),
      callback: function($$v) {
        _vm.dataModel[_vm.channel].active = $$v
      },
      expression: "dataModel[channel].active"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    class: {
      'disabled-block': !_vm.dataModel[_vm.channel].active
    },
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('label', {
    staticClass: "label-form"
  }, [_vm._v("Nombres")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-border-inset",
    attrs: {
      "type": "text",
      "placeholder": "Nombres",
      "disabled": !_vm.dataModel[_vm.channel].active
    },
    model: {
      value: (_vm.dataModel[_vm.channel].name),
      callback: function($$v) {
        _vm.dataModel[_vm.channel].name = $$v
      },
      expression: "dataModel[channel].name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('label', {
    staticClass: "label-form"
  }, [_vm._v("Apellidos")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-border-inset",
    attrs: {
      "type": "text",
      "placeholder": "Apellidos",
      "disabled": !_vm.dataModel[_vm.channel].active
    },
    model: {
      value: (_vm.dataModel[_vm.channel].lastname),
      callback: function($$v) {
        _vm.dataModel[_vm.channel].lastname = $$v
      },
      expression: "dataModel[channel].lastname"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.channel === 2),
      expression: "channel === 2"
    }],
    attrs: {
      "xs3": ""
    }
  }, [_c('label', {
    staticClass: "label-form"
  }, [_vm._v("Nº Registro Fiscal")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-border-inset",
    attrs: {
      "type": "text",
      "placeholder": "Nº de RUC, RUT, IVA, VAT",
      "disabled": !_vm.dataModel[_vm.channel].active
    },
    model: {
      value: (_vm.dataModel[_vm.channel].documentNumber),
      callback: function($$v) {
        _vm.dataModel[_vm.channel].documentNumber = $$v
      },
      expression: "dataModel[channel].documentNumber"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.channel === 3),
      expression: "channel === 3"
    }],
    attrs: {
      "xs3": ""
    }
  }, [_c('label', {
    staticClass: "label-form"
  }, [_vm._v("Nº de file")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-border-inset",
    attrs: {
      "type": "text",
      "placeholder": "Nº de Voucher",
      "disabled": !_vm.dataModel[_vm.channel].active
    },
    model: {
      value: (_vm.dataModel[_vm.channel].fileNumber),
      callback: function($$v) {
        _vm.dataModel[_vm.channel].fileNumber = $$v
      },
      expression: "dataModel[channel].fileNumber"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.channel === 4),
      expression: "channel === 4"
    }],
    attrs: {
      "xs3": ""
    }
  }, [_c('label', {
    staticClass: "label-form"
  }, [_vm._v("Nº de Voucher")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-border-inset",
    attrs: {
      "type": "text",
      "placeholder": "Nº de Voucher",
      "disabled": !_vm.dataModel[_vm.channel].active
    },
    model: {
      value: (_vm.dataModel[_vm.channel].voucher),
      callback: function($$v) {
        _vm.dataModel[_vm.channel].voucher = $$v
      },
      expression: "dataModel[channel].voucher"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.channel === 5),
      expression: "channel === 5"
    }],
    attrs: {
      "xs3": ""
    }
  }, [_c('label', {
    staticClass: "label-form"
  }, [_vm._v("Nº de Reserva")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-border-inset",
    attrs: {
      "type": "text",
      "placeholder": "Nº de Reserva",
      "disabled": !_vm.dataModel[_vm.channel].active
    },
    model: {
      value: (_vm.dataModel[_vm.channel].bookingNumber),
      callback: function($$v) {
        _vm.dataModel[_vm.channel].bookingNumber = $$v
      },
      expression: "dataModel[channel].bookingNumber"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('label', {
    staticClass: "label-form"
  }, [_vm._v("Correo electrónico")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-border-inset",
    attrs: {
      "type": "text",
      "placeholder": "nombre@mail.com",
      "disabled": !_vm.dataModel[_vm.channel].active
    },
    model: {
      value: (_vm.dataModel[_vm.channel].email),
      callback: function($$v) {
        _vm.dataModel[_vm.channel].email = $$v
      },
      expression: "dataModel[channel].email"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('label', {
    staticClass: "label-form"
  }, [_vm._v("Teléfono")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-border-inset input-form-prefix",
    attrs: {
      "type": "number",
      "prefix": "+51",
      "disabled": !_vm.dataModel[_vm.channel].active
    },
    model: {
      value: (_vm.dataModel[_vm.channel].phone),
      callback: function($$v) {
        _vm.dataModel[_vm.channel].phone = $$v
      },
      expression: "dataModel[channel].phone"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('label', {
    staticClass: "label-form"
  }, [_vm._v("País")]), _vm._v(" "), _c('v-select', {
    staticClass: "filter-select filter-select-main",
    attrs: {
      "autocomplete": "",
      "items": _vm.countries,
      "item-text": "name",
      "item-value": "id",
      "hide-details": "",
      "disabled": !_vm.dataModel[_vm.channel].active,
      "single-line": "",
      "bottom": ""
    },
    model: {
      value: (_vm.dataModel[_vm.channel].country),
      callback: function($$v) {
        _vm.dataModel[_vm.channel].country = $$v
      },
      expression: "dataModel[channel].country"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "mt-4": ""
    }
  }, [_c('v-divider', {
    staticClass: "divider-form"
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, _vm._l((_vm.additionals), function(additional) {
    return _c('v-flex', {
      key: additional.id,
      attrs: {
        "xs3": "",
        "mb-3": ""
      }
    }, [_c('v-checkbox', {
      staticClass: "input-checkbox",
      attrs: {
        "label": additional.name
      },
      model: {
        value: (_vm.selectedAdditionals),
        callback: function($$v) {
          _vm.selectedAdditionals = $$v
        },
        expression: "selectedAdditionals"
      }
    }), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset",
      attrs: {
        "type": "text",
        "readonly": "",
        "value": _vm._f("round")(additional.price)
      }
    })], 1)
  }))], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-end": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "text-xs-left": ""
    }
  }, [_c('label', {
    staticClass: "label-form"
  }, [_vm._v("Total")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-regular",
    attrs: {
      "type": "text",
      "readonly": "",
      "hide-details": "",
      "prefix": "$",
      "value": _vm._f("round")(_vm.totalAmount)
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-left": "",
      "mt-3": ""
    }
  }, [_c('label', {
    staticClass: "label-form"
  }, [_vm._v("Observaciones")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-textarea mt-1",
    attrs: {
      "no-resize": "",
      "multi-line": "",
      "rows": 3,
      "textarea": ""
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "justify-end": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-save btn-save-form mt-3",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n\t\t\t\t\t\tAceptar\n\t\t\t\t\t")])], 1)], 1)], 1)], 2)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 806:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1452)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1268),
  /* template */
  __webpack_require__(1574),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-04efa2f2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/74.db8662be439130dcfc85.js